export const Name = "trivia";
